const cardViewToggle = "cardView";

export const getCardViewToggle = () => {
    const val = window.localStorage.getItem(cardViewToggle);
    return val ? JSON.parse(val) : false;
}

export const setCardViewToggle = (val: boolean) => {
    window.localStorage.setItem(cardViewToggle, JSON.stringify(val));
}